import React from 'react';
import { TrendingUp, Coffee, Activity, Zap, DollarSign } from 'lucide-react';
import { howItWorksFeatures } from '../mockData';

const iconMap = {
  TrendingUp: TrendingUp,
  Coffee: Coffee,
  Activity: Activity,
  Zap: Zap,
  DollarSign: DollarSign
};

const colorMap = {
  blue: {
    bg: 'from-blue-500/20 to-blue-600/20',
    border: 'border-blue-500/30',
    icon: 'text-blue-400'
  },
  slate: {
    bg: 'from-slate-500/20 to-slate-600/20',
    border: 'border-slate-500/30',
    icon: 'text-slate-300'
  },
  purple: {
    bg: 'from-purple-500/20 to-purple-600/20',
    border: 'border-purple-500/30',
    icon: 'text-purple-400'
  },
  green: {
    bg: 'from-cyan-500/20 to-cyan-600/20',
    border: 'border-cyan-500/30',
    icon: 'text-cyan-400'
  },
  yellow: {
    bg: 'from-yellow-500/20 to-yellow-600/20',
    border: 'border-yellow-500/30',
    icon: 'text-yellow-400'
  }
};

const HowItWorks = () => {
  return (
    <section id="products" className="bg-slate-950 py-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4">
            How Does AI Auto Trading Work?
          </h2>
          <p className="text-xl text-slate-400 max-w-3xl mx-auto">
            Our advanced AI-powered trading software simplifies the complex world of Forex and Crypto trading into a seamless, automated process.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 max-w-7xl mx-auto">
          {howItWorksFeatures.map((feature, index) => {
            const IconComponent = iconMap[feature.icon];
            const colors = colorMap[feature.color];
            return (
              <div
                key={index}
                className="group bg-gradient-to-br from-slate-900/50 to-slate-900/30 backdrop-blur-sm border border-slate-800/50 rounded-xl p-6 hover:border-cyan-500/50 transition-all duration-300 hover:transform hover:-translate-y-1"
              >
                <div className={`w-14 h-14 bg-gradient-to-br ${colors.bg} border ${colors.border} rounded-lg flex items-center justify-center mb-5 group-hover:scale-110 transition-all duration-300`}>
                  <IconComponent className={`w-7 h-7 ${colors.icon}`} />
                </div>
                <h3 className="text-lg font-bold text-white mb-3">{feature.title}</h3>
                <p className="text-slate-400 text-sm leading-relaxed">{feature.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
